<script>
  import { fly } from "svelte/transition";
  import { styles } from "./styles";
  import { tourFunctions } from "../tour-functions";
  import { trackCallToActionClick } from "./analytics";

  export let callToAction = {
    enabled: false,
    type: "url",
    label: "Request Info",
    url: null,
    embedCode: null,
    bgColor: "#000000",
    textColor: "#ffffff",
    hoverBgColor: "#ffffff",
    hoverTextColor: "#000000",
    fontSize: 12,
    mobileEnabled: true,
  };

  // Mobile detection
  import UA from "ua-parser-js";
  const ua = new UA();
  let isMobile = ua.getResult().device["type"] == "mobile";
  const allowMobile = callToAction.mobileEnabled ?? true;
  const enabled = callToAction.enabled && (isMobile ? allowMobile : true);

  let isModalOpen = false;
  
  function handleClick() {
    // Track the CTA click
    const scene_id = tourFunctions.currentScene?.getId();
    const scene_title = tourFunctions.currentScene?.getTitle();
    trackCallToActionClick({
      link_text: callToAction.label,
      link_url: callToAction.url,
      scene_id,
      scene_title,
    });

    if (callToAction.type === "embed") {
      openModal();
    } else {
      tourFunctions.focus();
    }
  }

  function openModal() {
    isModalOpen = true;
  }

  function closeModal() {
    isModalOpen = false;
    tourFunctions.focus();
  }
</script>

{#if enabled}
  {#if callToAction.type === "url" && callToAction.url}
    <a
      use:styles={callToAction}
      transition:fly={{ y: -300, duration: 500 }}
      href={callToAction.url}
      on:click={handleClick}
      target="_blank"
      class="cta-button">{callToAction.label}</a
    >
  {:else if callToAction.type === "embed" && callToAction.embedCode}
    <button
      use:styles={callToAction}
      transition:fly={{ y: -300, duration: 500 }}
      class="cta-button"
      on:click={handleClick}>{callToAction.label}</button
    >
    {#if isModalOpen}
      <div class="modal" transition:fly={{ y: 300, duration: 500 }}>
        {@html callToAction.embedCode}
        <button on:click={closeModal}>Close</button>
      </div>
    {/if}
  {/if}
{/if}

<style>
  .cta-button {
    position: absolute;
    z-index: 900;
    top: 20px;
    right: 72px;
    display: inline-block;
    cursor: pointer;
    font-family: var(--font-body), sans-serif;
    font-weight: 700;
    line-height: 40px;
    color: var(--textColor);
    background-color: var(--bgColor);
    padding: 3px 16px;
    text-align: center;
    text-transform: uppercase;
    border-radius: 5px;
    border: none;
    text-decoration: none;
    font-size: calc(var(--fontSize) * 1px);
  }

  .cta-button:hover {
    color: var(--hoverTextColor);
    background-color: var(--hoverBgColor);
  }

  .modal {
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.9);
  }

  @media (max-width: 768px) {
    .cta-button {
      font-size: 12px;
      padding: 3px 10px;
    }
  }
</style>
